export default {
  mounted() {
    document.querySelector("body").classList.add("has-active-overlay")
  },

  beforeDestroy() {
    document.querySelector("body").classList.remove("has-active-overlay")
  }
}
